import React from 'react'
import { Modal, Button } from 'util/ui'
import { v4 as uuidV4 } from 'uuid'
import styles from '../../styles.less'

export default class ConfirmQuestionStep extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      answer: null,
    }
    this.componentId = uuidV4()
  }

  handleNext = () => {
    const { onNext } = this.props
    onNext(null)
  }

  render() {
    const { question, open } = this.props

    return (
      <Modal open={open} className={styles.billingModal}>
        <Modal.Header>Cancel account</Modal.Header>
        <Modal.Content>
          <div>
            {question.split('\n').map((item, index) => {
              const key = `${this.componentId}-${index}`
              return (
                <p key={key}>
                  {item}
                  <br />
                </p>
              )
            })}
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.handleNext}>Close</Button>
        </Modal.Actions>
      </Modal>
    )
  }
}
